export default __webpack_public_path__ + "static/B0130-3bff8f0924271a9fb0032a692e703c79.png";